// tslint:disable

import * as Cookie from 'js-cookie';
import * as React from 'react';
import { TemplateItem, Templates } from '../../../__templates/templates';

import './sidebar.scss';

export class SidebarComponent extends React.Component {
    private templates: Templates = new Templates();
    private template: TemplateItem;

    componentWillMount() {
        let site: any = {};
        try {
            site = JSON.parse(Cookie.get('site') as string) || {};
        } catch (e) {
            site = {};
        }

        this.template = this.templates.getTemplate('', 'sidebar', site.code);
    }

    render() {
        return React.createElement(this.template.component, {});
    }
}



// WEBPACK FOOTER //
// ./src/components/structurals/sidebar/sidebar.component.tsx